import state from './moduleSearchUserState.js'
import mutations from './moduleSearchUserMutations.js'
import actions from './moduleSearchUserActions.js'
import getters from './moduleSearchUserGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
